module.exports = __webpack_public_path__ + "static/media/topic.a5e5ed89.svg";